import React, { Component } from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import parse from 'html-react-parser'
// import Link from '../utils/link'

import Slider from "react-slick"
import Fade from 'react-reveal/Fade'
import Link from '../utils/link'

// import { DownArrow} from './icons'

class Testimonials extends Component {

  state = {
    sort: 1,
    variant: 0,
    modal: false,
    select: false,
    image: null,
  }

  settings = {
    ref: 'slider',
    // infinite: true,
    // speed: 600,
    // // fade:true,
    // autoplay: false,
    // autoplaySpeed: 5000,
    // slidesToShow: 3.5,
    // slidesToScroll: 1,
    // dots: false,
    // arrows: true,
    // cssEase: 'ease',
    // pauseOnHover: false,
    // focusOnSelect: false,
    // adaptiveHeight: true,
    // centerMode: true,
    infinite: true,
    slidesToShow: 1,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          infinite: false,
          arrows: false,
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          infinite: false,
          arrows: false,
          slidesToShow: 1.1
        }
      }
    ]
  }

  _toggleOffCanvas = () => {
    window?._toggleOffCanvas()
  }

  render() {

    let { title, testimonialSlider } = this.props

    return (
      <Fade bottom distance={'40px'} delay={500}>
        <section className='testimonials'>
          <div className='testimonials__inner'>
            <div className='testimonials__content'>
              <div>
                <h2 className='title'>
                  {parse(title)}
                </h2>
              </div>

              <Slider {...this.settings}>
                {testimonialSlider.map((el, i) => {
                  return (

                    <div key={i} className='testimonials-slider'>
                      <div className='testimonials-slider__inner'>
                        <div className='testimonials-slider__col'>

                          <div className='testimonials-slider__top'>
                            <div className='testimonials-slider__top--left'>
                              <div>
                                <h3>{el.ctaBoxTitle}</h3>
                                <p>{el.ctaBoxDescription}</p>
                              </div>
                            </div>
                            <div className='testimonials-slider__top--right'>
                              <div>
                                <h3>{el.ctaBoxTitleSecond}</h3>
                                <p>{el.ctaBoxDescriptionSecond}</p>
                              </div>
                            </div>
                          </div>

                          <div className='testimonials-slider__quote'>
                            <p>{parse(el.testimonial)}</p>
                            <span>{el.secondTextField}</span>
                          </div>
                        </div>
                        <div className='testimonials-slider__col'>
                          <div className='testimonials-slider__portrait'>
                            <h3>{el.name}</h3>
                            <h4>{el.jobTitle}</h4>
                            <div>
                              { el.link?.url && 
                                <Link className='btn btn--arrow' to={el.link.url}>
                                  <span>{el.link.title}</span>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="13.675" height="10.262" viewBox="0 0 13.675 10.262">
                                    <path d="M16.555,22.112l-.917-.9,3.584-3.584H8v-1.28H19.222l-3.605-3.605.917-.9,5.142,5.142Z" transform="translate(-8 -11.85)" fill="#FFFFFF" />
                                  </svg>
                                </Link>
                              }
                            </div>
                          </div>
                          <div className='testimonials-slider__gradient'></div>
                          <GatsbyImage image={getImage(el.portraitImage?.localFile)} alt={el.name} />
                        </div>
                      </div>
                    </div>
                  )
                })}
              </Slider>
            </div>

            {/* <DownArrow color={'#00D991'} /> */}

          </div>
        </section>
      </Fade>
    )
  }
}

export default Testimonials
